<script setup>
import ButtonBox from "@/components/ButtonBox.vue";
</script>
<template>
  <h1 class="text-2xl">Customer</h1>
  <hr class="my-4" />
  <div class="flex gap-20">
    <ButtonBox route="customer-new"> New Customer </ButtonBox>
    <ButtonBox route="customer-search"> Existing Customer </ButtonBox>
  </div>
</template>
